function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ionicons-v5-l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 368,
    y1: 368,
    x2: 144,
    y2: 144,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368,
    y1: 144,
    x2: 144,
    y2: 368,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    },
    fill: "#dd0031"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/close-outline.1df7396149235339b6fdba407ea4859f.svg";
export { ForwardRef as ReactComponent };